import axios from 'axios';

const baseURL = process.env.REACT_APP_API_URL + 'api/';

const axiosInstance = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const setAuthToken = (token) => {
  axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
};

export const post = (url, data) =>
  axiosInstance({
    method: 'POST',
    url,
    data,
  }).then((res) => res.data);

export const put = (url, data) =>
  axiosInstance({
    method: 'PUT',
    url,
    data,
  }).then((res) => res.data);

export const del = (url, data) =>
  axiosInstance({
    method: 'DELETE',
    url,
    data,
  }).then((res) => res.data);

export const get = (url, data) =>
  axiosInstance({
    method: 'GET',
    url,
    data,
  }).then((res) => res.data);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const errorResponseExists =
      error.response && typeof error.response.data === 'object';
    if (errorResponseExists) {
      // Return the API error response. Contains "message" as well.
      return Promise.reject(error.response.data);
    }

    // Return the Axios error object.
    // It contains it's own "message" in the error object.
    return Promise.reject(error);
  }
);



// WEBPACK FOOTER //
// ./src/core/api.js